import React from 'react'
const CallAction = () => {
    return (
        <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
            {/* <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="inner text-center">
                            <h2>Ready to start creating a standard website?</h2>
                            <a className="btn-default btn-border btn-large btn-white mt--40" href="/contact"><span>Purchase Imroz</span></a>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    )
}
export default CallAction;